import React, { useEffect, useState } from "react";
import MatchGame from "./components/matchGame";
import { torneos } from "../../../../services/torneos";
import './index.css'
import axios from "axios";
import { useFetchMatches } from "./hooks/useFetchMatches";
import TournamentsSelector from "./components/TournamnetsSelector";
import JournalSelector from "./components/JournalSelector";
import { useDispatch, useSelector } from "react-redux";
import CarouselPatternShip from "../CarouselPatternShip";
import { FaList } from "react-icons/fa6";
import { BsFillGridFill } from "react-icons/bs";

import GridMatchesView from "./components/GridMatchView";
import { setTeamsByTournament, showSelectorModalTeams } from "../../../../redux/actions/teams";
import TeasmSelectorModal from "./components/ModalTeams";
import MatchCard from "./components/matchGame/index2";



const MatchGames = ()=>{
    const {matches, selectedTournament,tournaments, labelJournals} = useFetchMatches({hasIdFromParams: false, id:''});
    const showSelectorTeams = useSelector(state => state?.teams?.showModal)
    const dispatch = useDispatch();
    const [isGridView, setIsGridView] = useState(false);
    const selectedTeam = useSelector(state => state?.teams?.selectedTeam)
    const selectedJournal = useSelector(state => state?.matches?.selectedJournal)
    const filterMatchesByJournal = selectedJournal === '' || selectedJournal === 'Todas' || !labelJournals?.[selectedJournal] ? matches : matches?.filter(match => match?.jornada === selectedJournal)
    const filterMatches = selectedTeam ? filterMatchesByJournal?.filter(match => (match?.equipoVisitante?._id === selectedTeam?._id || match?.equipoLocal?._id === selectedTeam?._id )) : filterMatchesByJournal

    useEffect(()=>{
        if(!selectedTournament) return;
        const teamsRequest = axios.post('https://web-production-58ed.up.railway.app/api/dt/getteams/bytorneo',{torneo: selectedTournament?._id});
        if (teamsRequest && typeof teamsRequest.then === 'function') {
            teamsRequest
                .then(res =>{
                    dispatch(setTeamsByTournament(res?.data?.equipos))
                }).catch(e => console.log('e',e))
        }


    },[selectedTournament])
    const renderMatchGame = ()=>{
        if(isGridView) return <GridMatchesView matches={filterMatches} />
        return filterMatches?.map(match => <MatchCard key={match?._id} match={match} />)
        return filterMatches?.map(match => <MatchGame matchInfo={match} />)
    }
    const renderCarouselPatternship = ()=>{
        if(!selectedTournament?.tienePatrocinadores) return null
        return(
            <div className="talachaapp-MatchGames-carousel-container" >
            <div></div>
            <CarouselPatternShip />
            <div></div>
            </div>
        )
    }
    return(
        <div className="talachaapp-MatchGames">
            {showSelectorTeams && <TeasmSelectorModal />}
            {renderCarouselPatternship()}
            <div className="talachaapp-MatchGames-title">
                <div className="talachaapp-MathGames-header" >
                    <TournamentsSelector tournaments={tournaments} />
                    <JournalSelector labelJournals={labelJournals} 
                     />
                     <div className="selector-team-by-tournament" onClick={()=> dispatch(showSelectorModalTeams(true))} >
                        <p>Equipos</p>
                    </div>
                <div  className="talachaapp-MatchGames-title-subcontainer">
                    {
                        isGridView ? (<FaList color="#ffffff" cursor={'pointer'} onClick={()=> setIsGridView(!isGridView)} />) :
                        (<BsFillGridFill color="#ffffff" cursor={'pointer'} onClick={()=> setIsGridView(!isGridView)} />)
                    }
                </div>
                </div>
            </div>
            <div className="talachaapp-MatchGames-container">
                <div></div>
                <div>
                    { matches?.length > 0 &&
                        renderMatchGame()
                    }
                </div>
                <div></div>

            </div>

        </div>
    )
}

export default MatchGames;